import React from "react";

function IconDownload({ color = "#000", ...props }) {
  return (
    <svg width="10.39" viewBox="0 0 10.39 14.58" {...props}>
      <defs>
        <style>{`.icon-download-1{fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}`}</style>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path d="M5.25 0.75L5.25 9.5" className="icon-download-1"></path>
          <path d="M8.31 7.25L5.25 10.31 2.19 7.25" className="icon-download-1"></path>
          <path d="M0.75 13.83L9.64 13.83" className="icon-download-1"></path>
        </g>
      </g>
    </svg>
  );
}

export default IconDownload;
